import { lazy } from 'react';

const ProductEdit = lazy(() => import('./ProductEdit'));

export default ProductEdit;
